import React, { useEffect, useState } from 'react';
import request from '../../../Helpers/API';
import { useHistory } from "react-router-dom";
import PlantillaScreen from '../../helpers/PlantillaScreen';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { LoaderScreen } from '../../components/LoaderScreen';
import { useLocation } from 'react-router-dom';
import { BoxFiltroScorecardVistaVendedor } from './Helper/BoxFitroScorecardVistaVendedor';
import { useBox } from './Helper/useBox';
import Swal from 'sweetalert2';
import { GetKey } from './Actions/GetContainer';
import { TablaVendedorDetalleImportes } from './TablaVendedorDetalleImportes';
import { TablaVendedorDetalleUnidades } from './TablaVendedorDetalleUnidades';
import { TablaImportesScorecardGerente } from './TablaImportesScorecardGerente';
import { TablaUnidadesScorecardGerente } from './TablaUnidadesScorecardGerente';
import { useSelector } from 'react-redux';

export const DashScorecardVendedorScreen = () => {
    const history = useHistory();
    const [data, setData] = useState([]);
    const [dataImportes, setDataImportes] = useState([]);
    const [dataDetalle, setDataDetalle] = useState([]);
    const location = useLocation();
    // const { state } = location;
    const { empleado } = useSelector((store) => store.usuario);
    const { idempleado } = useSelector((store) => store.usuario);



    const fechaActual = new Date();
    const ejercicioActual = fechaActual.getFullYear();
    const mesActual = fechaActual.getMonth() + 1;

    const initialStateboxfiltros = () => {
        return {
            ejercicioinicio: ejercicioActual,
            periodoinicio: "1",
            ejerciciofin: ejercicioActual,
            periodofin: mesActual,
            tabla: "L",
            tipo: "R",
            visualizacion: "U",
            pv: { adr: [], sucursal: [], vendedor: [] },
        };
    };

    const [boxstate, setBoxState] = useBox(initialStateboxfiltros());
    const [mostrarTUnidades, setMostrarTUnidades] = useState(true);
    const [mostrarTImportes, setMostrarTImportes] = useState(false);

    const [mostrarTVDUnidades, setMostrarTVDUnidades] = useState(true);
    const [mostrarTVDImportes, setMostrarTVDImportes] = useState(false);


    const onHome = () => {
        history.push("/Home/Dashboard")
    };

    const [filtroModificado, setFiltroModificado] = useState(false);

    const onBoxChange = (name, value) => {
        setFiltroModificado(true);
        setBoxState(name, value);
    };

    const getMonth = () => {
        const date = new Date();
        return date.getMonth() + 1;
    };
    var mes_actual = getMonth();

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    useEffect(() => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(`CargaScorecardporVendedorDash/MostrarScorecardVendedor`)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                setData(result)
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
            })
    }, []);

    const BoxClick = () => {
        return new Promise((res, req) => {
            setLoader({ ...loader, mostrar: true });
            if (boxstate.tipo === "R") {
                if (
                    boxstate.ejercicioinicio === undefined ||
                    boxstate.ejercicioinicio === null ||
                    boxstate.ejercicioinicio === "" ||
                    boxstate.ejercicioinicio === "0" ||
                    boxstate.ejercicioinicio === 0
                ) {
                    req("Favor de agregar el ejercicio de inicio");
                    return;
                }
                if (
                    boxstate.periodoinicio === undefined ||
                    boxstate.periodoinicio === null ||
                    boxstate.periodoinicio === "" ||
                    boxstate.periodoinicio === "0" ||
                    boxstate.periodoinicio === 0
                ) {
                    req("Favor de agregar el periodo de inicio");
                    return;
                }
                if (
                    boxstate.ejerciciofin === undefined ||
                    boxstate.ejerciciofin === null ||
                    boxstate.ejerciciofin === "" ||
                    boxstate.ejerciciofin === "0" ||
                    boxstate.ejerciciofin === 0
                ) {
                    req("Favor de agregar el ejercicio fin");
                    return;
                } else if (
                    Number(boxstate.ejercicioinicio) > Number(boxstate.ejerciciofin)
                ) {
                    req("El ejercicio de inicio debe ser menor o igual al ejercicio final");
                    return;
                }
                if (
                    boxstate.periodofin === undefined ||
                    boxstate.periodofin === null ||
                    boxstate.periodofin === "" ||
                    boxstate.periodofin === "0" ||
                    boxstate.periodofin === 0
                ) {
                    req("Favor de indicar el periodo final");
                    return;
                } else if (
                    Number(boxstate.ejercicioinicio) === Number(boxstate.ejerciciofin) &&
                    Number(boxstate.periodoinicio) > Number(boxstate.periodofin)
                ) {
                    req("El periodo de inicio no puede ser mayor al periodo fin");
                    setLoader({ ...loader, mostrar: true });
                    return;
                }
            }

            var sucursales = GetKey(boxstate.pv.sucursal, ["idSucursal"]);

            if (sucursales === undefined || sucursales === null || sucursales === "") {
                sucursales = "0";
            }

            var vendedores = GetKey(boxstate.pv.vendedor, ["idvendedor"]);

            if (vendedores === undefined || vendedores === null || vendedores === "") {
                vendedores = "0";
            }

            if (boxstate.tipo === 'R' && boxstate.visualizacion === "U") {
                request
                    .get(
                        `CargaScorecardporVendedorDash/MostrarScorecardVendedorporParametros?region=${0}&sucursal=${sucursales}&vendedor=${vendedores}&ejercicioinicio=${boxstate.ejercicioinicio}&periodoinicio=${boxstate.periodoinicio}&ejercicio=${boxstate.ejerciciofin}&mes_actual=${boxstate.periodofin}`
                    )
                    .then((result) => {
                        setLoader({ ...loader, mostrar: false });
                        setData(result);
                        setDataImportes([]);
                        setDataDetalle([]);

                        setMostrarTUnidades(true)
                        setMostrarTImportes(false)
                        setMostrarTVDUnidades(false)
                        setMostrarTVDUnidades(false)
                    })
                    .catch((error) => {
                        setLoader({ ...loader, mostrar: false });
                        Swal.fire("SCORECARD", JSON.stringify(error), "warning");
                    });
            }
            if (boxstate.tipo === 'R' && boxstate.visualizacion === "I") {
                request
                    .get(
                        `CargaScorecardporVendedorDash/MostrarScorecardVendedorporParametros?region=${0}&sucursal=${sucursales}&vendedor=${vendedores}&ejercicioinicio=${boxstate.ejercicioinicio}&periodoinicio=${boxstate.periodoinicio}&ejercicio=${boxstate.ejerciciofin}&mes_actual=${boxstate.periodofin}`
                    )
                    .then((result) => {
                        setLoader({ ...loader, mostrar: false });
                        setData([]);
                        setDataImportes(result);
                        setDataDetalle([]);

                        setMostrarTUnidades(false)
                        setMostrarTImportes(true)
                        setMostrarTVDUnidades(false)
                        setMostrarTVDUnidades(false)
                    })
                    .catch((error) => {
                        setLoader({ ...loader, mostrar: false });
                        Swal.fire("SCORECARD", JSON.stringify(error), "warning");
                    });
            }
            if (boxstate.tipo === 'D' && boxstate.visualizacion === "U") {
                request
                    .get(
                        `CargaScorecardporVendedorDash/MostrarScorecardVendedorDetalle?region=${0}&sucursal=${sucursales}&vendedor=${0}&ejercicio=${boxstate.ejercicioinicio}`
                    )
                    .then((result) => {
                        setLoader({ ...loader, mostrar: false });
                        setData([]);
                        setDataImportes([]);
                        setDataDetalle(result);


                        setMostrarTUnidades(false)
                        setMostrarTImportes(false)
                        setMostrarTVDUnidades(true)
                        setMostrarTVDImportes(false)
                    })
                    .catch((error) => {
                        setLoader({ ...loader, mostrar: false });
                        Swal.fire("SCORECARD", JSON.stringify(error), "warning");
                    });
            }
            if (boxstate.tipo === 'D' && boxstate.visualizacion === "I") {
                request
                    .get(
                        `CargaScorecardporVendedorDash/MostrarScorecardVendedorDetalle?region=${0}&sucursal=${sucursales}&vendedor=${0}&ejercicio=${boxstate.ejercicioinicio}`
                    )
                    .then((result) => {
                        setLoader({ ...loader, mostrar: false });
                        setData([]);
                        setDataImportes([]);
                        setDataDetalle(result);

                        setMostrarTUnidades(false)
                        setMostrarTImportes(false)
                        setMostrarTVDUnidades(false)
                        setMostrarTVDImportes(true)
                    })
                    .catch((error) => {
                        setLoader({ ...loader, mostrar: false });
                        Swal.fire("SCORECARD", JSON.stringify(error), "warning");
                    });
            }

        });
    };

    const guion = (value) => {
        return value <= 0 ? '-' : value;
    };

    const formatPorcentaje = (real, objetivo) => {
        if (objetivo === 0 && real === 0) {
            return null;
        }

        if (objetivo === 0) {
            return 100;
        }

        const porcentaje = (real / objetivo) * 100;

        return Math.min(porcentaje, 100);
    };


    const getBarColor = (porcentaje) => {
        if (porcentaje <= 60) {
            return "#f44336";
        } else if (porcentaje > 60 && porcentaje < 80) {
            return "#ffc107";
        } else {
            return "#035917";
        }
    };

    const capitalizeWords = (str) => {
        return str ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase()) : "";
    };


    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <PlantillaScreen
                titulo={`SCORECARD DE ${empleado?.toUpperCase()}`}
                className_main={1}
                className={"filtro-scorecard"}
            >
                <div className="dash-tabla-scorecard-gerente-actions">
                    <div
                        className="dash-tabla-scorecard-gerente-actions-regresar"
                        onClick={() => onHome()}
                    >
                        <ArrowBackIcon /> Regresar
                    </div>
                    <BoxFiltroScorecardVistaVendedor
                        boxState={boxstate}
                        onBoxChange={onBoxChange}
                        BoxClick={BoxClick}
                        datoslocal={initialStateboxfiltros()}
                        // subtitulo={state.subtitulo}
                        titulo_filtro="SCORECARD GENERAL"
                    ></BoxFiltroScorecardVistaVendedor>

                </div>

                <LoaderScreen loader={loader} />
                {mostrarTUnidades === true ? (
                    <div className="dash-tabla-container">
                        <TablaUnidadesScorecardGerente
                            boxstate={boxstate}
                            data={data}
                            initialStateboxfiltros={initialStateboxfiltros}
                            boxInicial={initialStateboxfiltros}
                            filtroModificado={filtroModificado}
                            idasesor={idempleado}
                            asesor={empleado}
                            ruta={"vendedor"}
                        />
                    </div>
                )
                    : mostrarTImportes === true ? (
                        // <div className="hola">
                        <div className="dash-tabla-container">
                            <TablaImportesScorecardGerente
                                boxstate={boxstate}
                                data={dataImportes}
                                initialStateboxfiltros={initialStateboxfiltros}
                            />
                            {/* </div> */}
                        </div>
                    ) : mostrarTVDUnidades === true ? (
                        // <div className="hola">
                        <div className="dash-tabla-container">
                            <TablaVendedorDetalleUnidades
                                boxstate={boxstate}
                                data={dataDetalle}
                                initialStateboxfiltros={initialStateboxfiltros}
                            />
                            {/* </div> */}
                        </div>
                    )
                        :
                        mostrarTVDImportes === true ? (
                            // <div className="hola">
                            <div className="dash-tabla-container">
                                <TablaVendedorDetalleImportes
                                    boxstate={boxstate}
                                    data={dataDetalle}
                                    initialStateboxfiltros={initialStateboxfiltros}
                                />
                                {/* </div> */}
                            </div>
                        )
                            : (
                                <p>No hay datos disponibles</p>
                            )}

            </PlantillaScreen>
        </div>
    )
}
